<template>
  <component :is="activeComponent[accountType]" />
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import * as ACCOUNT from '@/constants/accounts';

const Profile = () => import('./Profile');
const Clan = () => import('./Clan');
const Organization = () => import('./Organization');

export default {
  name: 'AccountEdit',
  computed: {
    ...mapState('current', ['account', 'accountType']),
    ...mapGetters(['accountChangedData']),

    activeComponent() {
      return {
        [ACCOUNT.PROFILE]: Profile,
        [ACCOUNT.ORGANIZATION]: Organization,
        [ACCOUNT.CLAN]: Clan,
      };
    },
  },
  created() {
    this.createEditModel(this.account._data);
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.hash !== '#saved' &&
      !this.$lodash.isEmpty(this.accountChangedData)
    ) {
      return this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_profile_confirm-cancel-changes',
            'If you navigate away from this page without saving your data, the changes will be lost'
          ),
        },
        events: {
          cancel: this.closeModal,
          confirm: () => {
            this.closeModal();
            this.gtmPush();
            this.clearEditData();
            this.updateAccountKey();
            next();
          },
        },
      });
    } else {
      this.gtmPush();
      this.clearEditData();
      this.updateAccountKey();

      next();
    }
  },
  methods: {
    ...mapActions(['openModal', 'closeModal']),
    ...mapMutations(['createEditModel', 'clearEditData', 'updateAccountKey']),
    gtmPush() {
      switch (this.accountType) {
        case 'profile':
          window.dataLayer.push({
            event: 'user edited',
            username: this.account.name || this.account.login,
            displayName: this.account.displayName,
            phone: this.account.phone,
            gender: this.account.gender,
            DoB: this.account.birthDate,
            country: this.account.country,
            registrationDate: this.account.registrationDate,
            favouriteGames: this.account.games,
            friendsCount: this.account.socialMetadata.friends,
            followersCount: this.account.socialMetadata.followed_by,
          });
          break;

        case 'organizazion':
          window.dataLayer.push({
            event: 'Organization edited',
          });
          break;

        case 'clan':
          window.dataLayer.push({
            event: 'team edited',
            teamName: this.accountChangedData.name,
            teamCountry: this.accountChangedData.country,
            username: this.myId,
            from: this.$route.path,
            membersCount: this.account.membersCount,
          });
          break;

        default:
          break;
      }
    },
  },
};
</script>
